export default "__VITE_ASSET__DRZWTHxI__"